export default "__VITE_ASSET__4oJgm2R$__"